import { GET_SHORTLIST_MISSION_ROLE_APPLICANT_ELIGIBILITY } from "graphql/queries";
import { useQueryData } from "hooks";

export default function useShortlistApplicant({ id }) {
  const { data, loading, error } = useQueryData({
    queryName: GET_SHORTLIST_MISSION_ROLE_APPLICANT_ELIGIBILITY,
    variables: { id },
    skip: !id,
  });

  return {
    data: data?.shortlistMissionRoleApplicantEligibility || {},
    loading,
    error,
  };
};
